var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItemContainer',{attrs:{"title":_vm.title}},[_c('v-checkbox',_vm._b({attrs:{"rules":_vm.myRules},model:{value:(_vm.ivalue),callback:function ($$v) {_vm.ivalue=$$v},expression:"ivalue"}},'v-checkbox',{ ..._vm.$attrs, ..._vm.$props },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }